// extracted by mini-css-extract-plugin
module.exports = {"comp":"Goods_comp__zpy0t"};